import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { GetCarpentryOrderOrderLineMetaData } from '../../Helpers/OrderInfoHelper'

export default function CarpentryOrderPaletInfo(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [productionOrder] = useState(props.productionOrder);
    const [orderLineMetaData] = useState(GetCarpentryOrderOrderLineMetaData(props.productionOrder.orderLineMetaData))

    return <div className={classes.orderInfo}>
        <div className={classes.header}>
            <div className={classes.leftHeader}>
                <div className={classes.orderno}>
                    {t("Type")}
                </div>
                <div className={classes.orderType} title={productionOrder.type}>
                    {productionOrder.type}
                </div>
            </div>
            <div className={classes.rightHeader}>
                <div className={classes.orderno}>
                    {t("Quantity")}
                </div>
                <div className={classes.orderNumber}>
                    {productionOrder.quantity}
                </div>
            </div>
        </div>

        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    <TableRow key={orderLineMetaData.Length} className={classes.row}>
                        < TableCell className={classes.nameCell}>
                            {t("Length")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{parseInt(orderLineMetaData.Length)}</TableCell>
                    </TableRow>
                    <TableRow key={orderLineMetaData.Width} className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Width")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{parseInt(orderLineMetaData.Width)}</TableCell>
                    </TableRow>
                    <TableRow key={orderLineMetaData.UpperPlate} className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Top plate")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{orderLineMetaData.UpperPlate}</TableCell>
                    </TableRow>
                    <TableRow key={orderLineMetaData.UnderPlate} className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Bottom plate")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{orderLineMetaData.UnderPlate}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div >
}

const useStyles = makeStyles({
    orderInfo: {
        float: "left",
        paddingLeft: "30px",
        width: "45%",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        marginBottom: "20px"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px",
        wordWrap: "break-word"
    },
    orderType: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        marginBottom: "10px",
        wordWrap: "break-word"
    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        marginBottom: "10px",
        wordWrap: "break-word"
    },
    orderTable: {
        display: "block"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    rightHeader: {
        textAlign: "right",
        width: "50%",
        float: "right",
    },
    leftHeader: {
        width: "50%",
        float: "left"
    }
});